/** @format */

import { baseEnvironment } from '../../../shared/config/base-environment';
import { IEnvironment } from '../../../shared/config/environment.interface';

export const environment: IEnvironment = {
  ...baseEnvironment,
  idoAuth: {
    url: 'https://id.sesio.io', issuer: 'https://id.sesio.io', clientId: 'engine-web',
  },
  appName: 'Sesio',
  production: true,
  env: 'production',
};
